// extracted by mini-css-extract-plugin
export default {"FlexContainer":"FlexContainer-module__FlexContainer__O4nYi","Column":"FlexContainer-module__Column__ivZLr"};